import React, { useState, memo } from 'react';
import { addDays } from 'utils/date';
import sha1 from 'sha1';

import { saveCookie, getCookie } from 'utils/cookie';

import { Banner } from './Banner';

const URGENCY_BANNER_DAYS_TO_SHOW_AGAIN = 5; // days
const URGENCY_BANNER_COOKIE = 'wtr_cookie_urgency_banner';

export interface UrgencyBannerProps {
  html?: string;
  type: 'info' | 'warning' | 'danger';
}

const UrgencyBanner = ({ html = '', type }: UrgencyBannerProps) => {
  // deepcode ignore InsecureHash - sha1 hash used for caching for performance purposes with no cryptographic requirements
  const hashValue = sha1(html + type);
  const cookieValue = getCookie(URGENCY_BANNER_COOKIE);
  const [show, setShow] = useState(!(cookieValue === hashValue));

  const close = () => {
    setShow(false);
    saveCookie(
      URGENCY_BANNER_COOKIE,
      hashValue,
      addDays(new Date(), URGENCY_BANNER_DAYS_TO_SHOW_AGAIN),
    );
  };

  if (!show) return null;

  return (
    <Banner type={type} onClose={close}>
      {{ __html: html }}
    </Banner>
  );
};

UrgencyBanner.displayName = 'UrgencyBanner';

export default memo(UrgencyBanner);
